import { isNil } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { localStorage } from '@fiverr-private/futile';

const STORAGE_KEY_PREFIX = 'FMP_ENCOURAGE_APP_DOWNLOAD';
const DATE_KEY = 'date';

/**
 * Get local storage key for the last seen date.
 * key is structured by feature prefix and user id
 * @returns {string} storage key
 */
const getStorageKey = () => {
    const { userId } = getContext();

    return `${STORAGE_KEY_PREFIX}_${userId}`;
};

/**
 * Returns whether the user was shown the app download modal, according to the local storage
 * @returns {boolean} has seen the modal
 */
const hasShown = () => {
    const storageKey = getStorageKey();
    const appDownloadShownStorage = localStorage.get(storageKey);

    if (!appDownloadShownStorage) {
        return false;
    }

    return !isNil(appDownloadShownStorage) && ! isNil(appDownloadShownStorage[DATE_KEY]);
};

/**
 * Updates the last seen date in local storage.
 */
export const updateShown = () => {
    const storageKey = getStorageKey();

    const appDownloadShownStorage = {
        [DATE_KEY]: Date.now()
    };

    localStorage.set(storageKey, appDownloadShownStorage);
};

/**
 * Returns whether to show the app download experience in the modal
 * @returns {boolean}
 */
export const shouldShow = (senderInfo) => {
    const { userId, isMobile } = getContext();

    const { hasApp } = senderInfo;
    const noneAppUser = hasApp === false;

    return userId && !hasShown() && !isMobile && noneAppUser;
};
